import { mergeObjectsButOverrideArrays } from '@@/utils/merge';

export function mergeConfig<T = unknown>(
  defaultConfig: T,
  overrideConfig: DeepPartial<T>
) {
  return mergeObjectsButOverrideArrays(defaultConfig, overrideConfig);
}

export function mergeConfigs<T = unknown>(...configs: T[]) {
  return configs.reduce((base, override) =>
    mergeObjectsButOverrideArrays(base, override)
  );
}

export default mergeConfig;
